<template>
  <w-flex justify-center align-center v-if="$zutil.role('Al Man')">
    <div class="w-card__content content-hardcode">
        <w-flex class="mt3">
         <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
         </w-button>
       </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Tarikh</th>
          <th class="w-table__header  text-left">Vaksin</th>
          <th class="w-table__header  text-left">Brand</th>
          <th class="w-table__header  text-left">Al Man</th>
          <th class="w-table__header  text-left"></th>
          
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >
              <template v-if="dt.pemeriksaan_id">
                <inertia-link :href="$route('pemeriksaan.show',dt.pemeriksaan_id)" >{{dt.tarikh}}</inertia-link>
              </template>
              <template v-else>
                {{dt.tarikh}}
              </template>
            </td>
            <td class="w-table__cell text-left" >{{dt.vaksin}}</td>
            <td class="w-table__cell text-left" >{{dt.brand}}</td>
            <td class="w-table__cell text-left" >{{dt.user}}</td>
            <td>
              <template v-if="$page.props.auth.user.id == dt.user_id">
              <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(dt.id)">
                <w-icon xs class="mr-auto"> fal fa-trash</w-icon>PADAM
              </w-button>
              </template>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Vaksin Ternakan
    </template>
    <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >
      <z-input label="Tarikh *" type="date" v-model="form.tarikh"  :validators="[validators.required]" />
       <w-select :items="lkp_vaksin" label="Vaksin *"  v-model="form.lkp_vaksin_id" @input="getLkpBrandvaksin(form.lkp_vaksin_id)" :validators="[validators.required]"/>
       <w-select :items="lkp_brand_vaksin" label="Brand *"  v-model="form.lkp_brand_vaksin_id" @input="getVaksin(form.lkp_brand_vaksin_id)" :validators="[validators.required]"/>
      <w-select :items="vaksin" label="No Vaksin *"  v-model="form.vaksin_id"  :validators="[validators.required]"/>
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Simpan</w-button>
    </template>
  </w-dialog>

  

</template>

<script>
export default {
  name: "Vaksin",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {
        lkp_vaksin_id : '',
        lkp_brand_vaksin_id : '',
        vaksin_id : '',
        tarikh : ''
      },
      datas : [],
      lkp_vaksin : [],
      lkp_brand_vaksin : [],
      vaksin : [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      validators: {
        required: value => !!value || 'Wajib Isi.',
        
      }, 
      
    }
  },
  methods:{
    add(){
      this.dialog.show = true
      this.form = {
        llkp_vaksin_id : '',
        lkp_brand_vaksin_id : '',
        vaksin_id : '',
        tarikh : ''
      }
    },
    getLkpVaksin(){
      this.$zcomm.get(this.api_service + 'lookup/vaksin/'+this.data.lkp_ternakan_id, {}).then(res => {
        this.lkp_vaksin = res
      })
    },
    getLkpBrandvaksin(i){
      this.$zcomm.get(this.api_service + 'lookup/brand_vaksin/'+i, {}).then(res => {
        this.lkp_brand_vaksin = res
      })
    },
    getVaksin(i){
      this.$zcomm.get(this.api_service + 'lookup/stok_vaksin/'+i, {}).then(res => {
        this.vaksin = res
      })
    },
    getData(){
      this.$zcomm.get(this.api_service + 'ternakan/vaksin/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },

    submit() {
      if(this.form.tarikh && this.form.lkp_vaksin_id > 0 && this.form.lkp_brand_vaksin_id > 0 && this.form.vaksin_id > 0){
        this.form.ternakan_id = this.data.id
        this.form.lkp_ternakan_id = this.data.lkp_ternakan_id
        this.form.lkp_status_id = 1
        this.$zcomm.add( 'vaksin.ternakan.store', this.form)
        .then(res => {
          
          this.dialog.show = false;
          this.getData()
        })
        .finally(() => {
            this.dialog.loading = false;

        });
      }
    },
    destroy(id) {
           
            if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
                this.$zcomm.delete('vaksin.ternakan.destroy', id)
                    .then(res => {
                      
                      
                      this.getData()
                    })
                    .finally(() => {
                      // $('#' + this.resourceurl).modal('hide')
                    });
            }
        },
    
  },
      
  mounted() {
    this.getData()
    this.getLkpVaksin()
    
  }
}
      

</script>  
